<template>
  <div class="text-content my-5">
    <div class="text-[#3c3c3c] font-medium mb-2">Tickets</div>
    <div class="flex" v-for="(ticket, index) in summary.items" :key="index">
      <div class="flex-1">{{ ticket.category }} - {{ ticket.label }}</div>
      <div>{{ dineroFormat(ticket.price) }}</div>
    </div>

    <div class="flex mt-5" v-if="reservation.serviceCharge > 0">
      <div class="flex-1">Service Charge</div>
      <div>
        {{ dineroFormat(summary.serviceCharge) }}
      </div>
    </div>

    <div class="flex text-n3yellow font-bold" v-if="reservation.price > 0">
      <div class="flex-1">Total Cost</div>
      <div>
        {{ dineroFormat(summary.total) }}
      </div>
    </div>
  </div>
</template>
<script>
import { computed, reactive, toRefs } from "vue";
import { useStore } from "vuex";
import { moneyFormat, dineroFormat } from "@/utils/helper";
import Dinero from "dinero.js";

export default {
  name: "TicketSummary",
  setup() {
    const store = useStore();
    const state = reactive({
      selectedSeats: computed(() => store.getters["reservation/selectedSeats"]),
      reservation: computed(() => store.state.reservation.reservation),
      show: computed(() => store.state.show.show),
      summary: computed(() => {
        const paymentCurrency = state.show.paymentCurrency || "EUR";
        const stripeTransactionFee = state.show.fees?.stripeTransactionFee || 0;
        const percentage = state.show.fees?.percentage || 0;
        const items = [];
        let itemTotal = Dinero({
          amount: 0,
          currency: paymentCurrency,
        });
        state.selectedSeats.map((ticket) => {
          let ticketPrice = Dinero({
            amount: ticket.price * 100,
            currency: paymentCurrency,
          });
          itemTotal = itemTotal.add(ticketPrice);
          items.push({
            category: ticket.category,
            label: ticket.label,
            price: ticketPrice,
          });
        });
        const subTotal = itemTotal;

        const serviceCharge = itemTotal
          .add(
            Dinero({
              amount: stripeTransactionFee,
              currency: paymentCurrency,
            })
          )
          .divide((100 - percentage) / 100)
          .subtract(subTotal);

        return {
          total: subTotal.add(serviceCharge),
          serviceCharge: serviceCharge,
          items,
        };
      }),
    });
    return {
      ...toRefs(state),
      moneyFormat,
      dineroFormat,
    };
  },
};
</script>
